import React from "react";
import WorkScheduleGenericSkeleton from "./WorkScheduleGenericSkeleton";

function WorkScheduleDetailSkeleton() {
  return (
    <>
      <WorkScheduleGenericSkeleton />
    </>
  );
}

export default WorkScheduleDetailSkeleton;
